export class FileItem {
  id?: string;
  parentId?: string;
  name?: string;
  mimeType?: string;
  webContentLink?: string;
  webViewLink?: string;
  fileExtension?: string;
  createdTime?: string;
  modifiedTime?: string;
  size?: number;

  constructor({
    id,
    parentId,
    name,
    mimeType,
    webContentLink,
    webViewLink,
    fileExtension,
    createdTime,
    modifiedTime,
    size
  }: {
    id?: string;
    parentId?: string;
    name?: string;
    mimeType?: string;
    webContentLink?: string;
    webViewLink?: string;
    fileExtension?: string;
    createdTime?: string;
    modifiedTime?: string;
    size?: number;
  } = {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.mimeType = mimeType;
    this.webContentLink = webContentLink;
    this.webViewLink = webViewLink;
    this.fileExtension = fileExtension;
    this.createdTime = createdTime;
    this.modifiedTime = modifiedTime;
    this.size = size;
  }
}
